export default "__VITE_ASSET__gBGNCe2f__"